/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { BooleanDlmBaseResponse } from '../models/boolean-dlm-base-response';
import { OutputDisplayTypeResponse } from '../models/output-display-type-response';
import { OutputDisplayTypeResponseDlmBaseResponse } from '../models/output-display-type-response-dlm-base-response';
import { OutputDisplayTypeResponseListDlmBaseResponse } from '../models/output-display-type-response-list-dlm-base-response';

@Injectable({
  providedIn: 'root',
})
export class OutputDisplayTypeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiOutputDisplayTypeOutputDisplayTypesGet
   */
  static readonly ApiOutputDisplayTypeOutputDisplayTypesGetPath = '/api/OutputDisplayType/output-display-types';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeOutputDisplayTypesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOutputDisplayTypeOutputDisplayTypesGet$Plain$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<OutputDisplayTypeResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeOutputDisplayTypesGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutputDisplayTypeResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeOutputDisplayTypesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOutputDisplayTypeOutputDisplayTypesGet$Plain(params?: {
    archived?: boolean;
  }): Observable<OutputDisplayTypeResponseListDlmBaseResponse> {

    return this.apiOutputDisplayTypeOutputDisplayTypesGet$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<OutputDisplayTypeResponseListDlmBaseResponse>) => r.body as OutputDisplayTypeResponseListDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeOutputDisplayTypesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOutputDisplayTypeOutputDisplayTypesGet$Json$Response(params?: {
    archived?: boolean;
  }): Observable<StrictHttpResponse<OutputDisplayTypeResponseListDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeOutputDisplayTypesGetPath, 'get');
    if (params) {
      rb.query('archived', params.archived, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutputDisplayTypeResponseListDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeOutputDisplayTypesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOutputDisplayTypeOutputDisplayTypesGet$Json(params?: {
    archived?: boolean;
  }): Observable<OutputDisplayTypeResponseListDlmBaseResponse> {

    return this.apiOutputDisplayTypeOutputDisplayTypesGet$Json$Response(params).pipe(
      map((r: StrictHttpResponse<OutputDisplayTypeResponseListDlmBaseResponse>) => r.body as OutputDisplayTypeResponseListDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiOutputDisplayTypeOutputDisplayTypePost
   */
  static readonly ApiOutputDisplayTypeOutputDisplayTypePostPath = '/api/OutputDisplayType/output-display-type';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeOutputDisplayTypePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeOutputDisplayTypePost$Plain$Response(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeOutputDisplayTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeOutputDisplayTypePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeOutputDisplayTypePost$Plain(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<OutputDisplayTypeResponseDlmBaseResponse> {

    return this.apiOutputDisplayTypeOutputDisplayTypePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>) => r.body as OutputDisplayTypeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeOutputDisplayTypePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeOutputDisplayTypePost$Json$Response(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeOutputDisplayTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeOutputDisplayTypePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeOutputDisplayTypePost$Json(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<OutputDisplayTypeResponseDlmBaseResponse> {

    return this.apiOutputDisplayTypeOutputDisplayTypePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>) => r.body as OutputDisplayTypeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiOutputDisplayTypeEditOutputDisplayTypePost
   */
  static readonly ApiOutputDisplayTypeEditOutputDisplayTypePostPath = '/api/OutputDisplayType/edit-output-display-type';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeEditOutputDisplayTypePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeEditOutputDisplayTypePost$Plain$Response(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeEditOutputDisplayTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeEditOutputDisplayTypePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeEditOutputDisplayTypePost$Plain(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<OutputDisplayTypeResponseDlmBaseResponse> {

    return this.apiOutputDisplayTypeEditOutputDisplayTypePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>) => r.body as OutputDisplayTypeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeEditOutputDisplayTypePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeEditOutputDisplayTypePost$Json$Response(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeEditOutputDisplayTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeEditOutputDisplayTypePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeEditOutputDisplayTypePost$Json(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<OutputDisplayTypeResponseDlmBaseResponse> {

    return this.apiOutputDisplayTypeEditOutputDisplayTypePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>) => r.body as OutputDisplayTypeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiOutputDisplayTypeDeleteOutputDisplayTypePost
   */
  static readonly ApiOutputDisplayTypeDeleteOutputDisplayTypePostPath = '/api/OutputDisplayType/delete-output-display-type';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeDeleteOutputDisplayTypePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeDeleteOutputDisplayTypePost$Plain$Response(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeDeleteOutputDisplayTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeDeleteOutputDisplayTypePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeDeleteOutputDisplayTypePost$Plain(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<OutputDisplayTypeResponseDlmBaseResponse> {

    return this.apiOutputDisplayTypeDeleteOutputDisplayTypePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>) => r.body as OutputDisplayTypeResponseDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeDeleteOutputDisplayTypePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeDeleteOutputDisplayTypePost$Json$Response(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeDeleteOutputDisplayTypePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeDeleteOutputDisplayTypePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiOutputDisplayTypeDeleteOutputDisplayTypePost$Json(params?: {
    body?: OutputDisplayTypeResponse
  }): Observable<OutputDisplayTypeResponseDlmBaseResponse> {

    return this.apiOutputDisplayTypeDeleteOutputDisplayTypePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<OutputDisplayTypeResponseDlmBaseResponse>) => r.body as OutputDisplayTypeResponseDlmBaseResponse)
    );
  }

  /**
   * Path part for operation apiOutputDisplayTypeRestorePost
   */
  static readonly ApiOutputDisplayTypeRestorePostPath = '/api/OutputDisplayType/restore';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeRestorePost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOutputDisplayTypeRestorePost$Plain$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeRestorePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeRestorePost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOutputDisplayTypeRestorePost$Plain(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiOutputDisplayTypeRestorePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiOutputDisplayTypeRestorePost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOutputDisplayTypeRestorePost$Json$Response(params?: {
    id?: number;
  }): Observable<StrictHttpResponse<BooleanDlmBaseResponse>> {

    const rb = new RequestBuilder(this.rootUrl, OutputDisplayTypeService.ApiOutputDisplayTypeRestorePostPath, 'post');
    if (params) {
      rb.query('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BooleanDlmBaseResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiOutputDisplayTypeRestorePost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiOutputDisplayTypeRestorePost$Json(params?: {
    id?: number;
  }): Observable<BooleanDlmBaseResponse> {

    return this.apiOutputDisplayTypeRestorePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BooleanDlmBaseResponse>) => r.body as BooleanDlmBaseResponse)
    );
  }

}
